import React from 'react';
import { Search, X } from 'lucide-react';
import { UI_TEXT } from '../utils/constants';

const SearchBar = ({ searchQuery, setSearchQuery }) => {
  const hasText = searchQuery.length > 0;

  return (
    <div className="search-glow relative transition-all duration-200">
      {/* Search icon — turns amber when there is text */}
      <div className="absolute inset-y-0 left-0 pl-5 flex items-center pointer-events-none">
        <Search
          className={`h-5 w-5 transition-colors duration-200 ${hasText ? 'text-primary' : 'text-gray-400'}`}
          aria-hidden="true"
        />
      </div>

      <input
        type="text"
        className="
          block w-full pl-12 pr-12 py-4
          bg-surface-high border-0 rounded-full
          text-on-surface text-base placeholder-gray-400
          focus:outline-none focus:ring-2 focus:ring-primary/40
          transition-all duration-200
        "
        placeholder={UI_TEXT.searchPlaceholder}
        aria-label={UI_TEXT.searchLabel}
        role="searchbox"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />

      {/* Clear button — visible only when there is text */}
      {hasText && (
        <button
          type="button"
          aria-label="Очистити пошук"
          onClick={() => setSearchQuery('')}
          className="
            absolute inset-y-0 right-0 pr-5 flex items-center
            text-gray-400 hover:text-primary
            rounded-full
            focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-1
            transition-colors duration-150
          "
        >
          <X className="h-5 w-5" aria-hidden="true" />
        </button>
      )}
    </div>
  );
};

export default SearchBar;
